import { z } from 'zod';
/**
 * The two brands a craftsman is sold under. The backend keeps its own `Team` enum because TypeORM columns are typed
 * against it; converging the two is follow-up work.
 */
export const teamSchema = z.enum(['Houzy', 'Devis']);
export const Team = teamSchema.enum;
